import React from 'react';
import '../css/language-toggle.sass';
import StaticElementButton from './StaticElementButton';

interface LanguageToggleProps {
  onLanguageChange?: Function;
  selectedLanguage?: 'en' | 'es';
  languagesOptionsCsv?: 'English,Español';
  languagesAbbreviationCsv?: 'en,es';
  showToggle?: boolean;
  theme?: 'day' | 'night';
}

export default function LanguageToggle(props: LanguageToggleProps) {
  const {
    languagesAbbreviationCsv = 'en,es',
    languagesOptionsCsv = 'English,Español',
    selectedLanguage = 'en'
  } = props;
  const supportedLanguageList = languagesAbbreviationCsv.split(',');
  const languageOptions = languagesOptionsCsv.split(',');
  return (
    <>
      {props.showToggle && (
        <>
          <span className="sr-only">View site in:</span>
          {/* visually-hidden content  to support screenReaders */}
          <ul className={`${props.theme} language-toggle-list`}>
            {supportedLanguageList.map((lang: string, index: number) => {
              return (
                <li>
                  {lang === selectedLanguage ? (
                    <span className="selected-lang">
                      {languageOptions[index]}
                    </span>
                  ) : (
                    <StaticElementButton
                      type="span"
                      className="select-btn"
                      onClick={(e: any) => {
                        e.preventDefault();
                        if (props.onLanguageChange)
                          props.onLanguageChange(lang);
                      }}
                      id={lang}
                      name={lang}
                      key={lang}
                      label={languageOptions[index]}
                    >
                      {languageOptions[index]}
                    </StaticElementButton>
                  )}
                </li>
              );
            })}
          </ul>
        </>
      )}
    </>
  );
}
